import React, { memo } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import ClinicalHeroCard from './ClinicalHeroCard';
import FeaturedLoader from '../../../skeleton/clinicalVideo/FeaturedLoader';
SwiperCore.use([Pagination, Navigation]);
const ClinicalFeaturedSection = ({ clinicalVideos, loader, activeIdx, onSlideChange, clsName }) => {
  const [isSwiperLoaded, setSwiperLoaded] = React.useState(false);
  return (
    <div className="clinicalFeatured pe-0 pe-xl-20" id="clinical_videos_featured_card">
      {clinicalVideos?.length > 0 && !loader ? (
        <Swiper
          className={`clinicalFeaturedSlide shadow position-relative overflow-y-visible ${clsName}`}
          slidesPerView={1}
          loop={false}
          // pagination={true}
          pagination={{ clickable: true }}
          onSlideChange={onSlideChange}
          onSwiper={(swiper) => setSwiperLoaded(true)}
        >
          {isSwiperLoaded &&
            clinicalVideos?.slice(0, 3)?.map((_video, _idx) => (
              <SwiperSlide
                key={_idx + 1}
                className="clinicalFeaturedMain d-flex flex-wrap flex-md-row-reverse align-items-center position-relative overflow-hidden h-auto bg-white"
              >
                <ClinicalHeroCard _video={_video} _idx={_idx} activeIdx={activeIdx} />
              </SwiperSlide>
            ))}
        </Swiper>
      ) : loader ? (
        <FeaturedLoader />
      ) : null}
    </div>
  );
};

export default memo(ClinicalFeaturedSection);
